import React from 'react';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import OptimizedImage from 'components/shared/OptimizedImage';

class SMFeatureRoomView extends React.Component {
  
  constructor(props) {
    super(props);
  }
  
  componentDidMount() {
  }
  
  render() {
    let rows = [];
    const roomImageWidth = 110;
    const roomImageHeight = 110;

    this.props.roomFeatures.forEach((roomFeature, index) => {
      const room = roomFeature.item;
      const roomImageUrl = SMFormatHelper.imageURLWithTransform(room.thumbnails[0].image, {width: roomImageWidth, height: roomImageHeight});
      rows.push(
        <a key={room.id} href={Routes.space_room_path(room.space.username, room.uid)}>
          <div className="lpsearch-sidebar__space clearfix">
            <div className="lpsearch-sidebar__space-img">
              <OptimizedImage
                src={roomImageUrl}
                alt={SMFormatHelper.roomName(room)}
                width={roomImageWidth}
                height={roomImageHeight}
              />
            </div>
            <div className="lpsearch-sidebar__space-text">
              <h3 className="lpsearch-sidebar__space-title">{SMFormatHelper.roomName(room)}</h3>
              <ul className="units-item__body-info lpsearch-sidebar__info">
                <li><i className="fa fa-user mr5"></i>{SMFormatHelper.capacity(room)}</li>
                <li><i className="fa fa-map-marker mr5"></i>{room.space.state_text}</li>
              </ul>
              <p className="lpsearch-sidebar__space-price">{room.min_price_text}<span className="units-item__item-per">{SMFormatHelper.priceUnit(room.min_price_unit_text)}</span></p>
            </div>
          </div>
        </a>
      );
    });
    return(
      <div className="site-sidebar">
        <h2 className="site-sidebar__headline">{I18n.t("service.label_000011")}</h2>
        {rows}
        <div className="lpsearch-sidebar__space-more">
          <a href={Routes.feature_path("top_feature")} className="a__underline">{I18n.t("service.label_000012")}</a>
        </div>
      </div>
    );
  }
  
}
export default SMFeatureRoomView;



// WEBPACK FOOTER //
// ./app/javascript/components/features/SMFeatureRoomView.jsx